<template>
  <div class="app-navbar-wrapper">
    <b-navbar toggleable="lg" type="dark" class="app-navbar">
      <b-navbar-brand href="#" class="brand-logo">
        <img src="../assets/aslogo.png" width="34" alt="Logo">
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <b-navbar-nav>
          <b-nav-item v-if="user.role === fixed.roles.Master || user.role === fixed.roles.Norway"
                      class="d-none d-sm-block">
            <b-link to="/invoices" class="text-decoration-none menu-color">
              INVOICES
            </b-link>
          </b-nav-item>

          <b-nav-item v-if="user.role === fixed.roles.Master || user.role === fixed.roles.Norway">
            <b-link to="/local-stock" class="text-decoration-none menu-color">
              SEARCH AND ORDER
            </b-link>
          </b-nav-item>

          <b-nav-item v-if="user.role === fixed.roles.Master || user.role === fixed.roles.Norway">
            <b-link to="/regos-parts" class="text-decoration-none menu-color">
              REGOS
            </b-link>
          </b-nav-item>

          <b-nav-item v-if="user.role === fixed.roles.Master || user.role === fixed.roles.Norway"
                      class="d-none d-sm-block">
            <b-link to="/virtuals" class="text-decoration-none menu-color">
              WORKSHOP
            </b-link>
          </b-nav-item>

          <b-nav-item v-if="user.role === fixed.roles.Master || user.role === fixed.roles.Norway"
                      class="d-none d-sm-block">
            <b-link to="/manual" class="text-decoration-none menu-color">
              BD STOCK
            </b-link>
          </b-nav-item>

          <b-nav-item-dropdown v-if="user.role === fixed.roles.Master || user.role === fixed.roles.Norway"
                               text="AIRSUSPENSION" class="dropdown-nav-link">

            <b-dropdown-item>
              <b-link to="/as/scan" class="text-decoration-none">
                STOCK MANAGEMENT
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <b-link to="/as/products" class="text-decoration-none">
                PRODUCTS IN STOCK
              </b-link>
            </b-dropdown-item>

          </b-nav-item-dropdown>

          <b-nav-item-dropdown v-if="user.role === fixed.roles.Master || user.role === fixed.roles.Norway"
            text="CHECKS" class="dropdown-nav-link">

            <b-dropdown-item>
              <b-link to="/products-on-location" class="text-decoration-none">
                CHECK STOCK
              </b-link>
            </b-dropdown-item>

            <b-dropdown-item>
              <b-link to="/confirm-received" class="text-decoration-none">
                CHECK BOX ITEMS
              </b-link>
            </b-dropdown-item>

          </b-nav-item-dropdown>

          <b-nav-item v-if="user.role === fixed.roles.Master || user.role === fixed.roles.Norway"
                      class="d-none d-sm-block">
            <b-link to="/ref-lager" class="text-decoration-none menu-color">
              REF LAGER
            </b-link>
          </b-nav-item>

          <b-nav-item v-if="user.role === fixed.roles.Master || user.role === fixed.roles.Norway"
                      class="d-lg-none">
            <b-link to="/scanner" class="text-decoration-none menu-color">
              SCANNER
            </b-link>
          </b-nav-item>

          <b-nav-item v-if="user.role !== fixed.roles.Merchant" class="d-none d-sm-block">
            <b-link to="/poland-orders" class="text-decoration-none menu-color">
              ORDERS
            </b-link>
          </b-nav-item>

          <b-nav-item v-if="user.role !== fixed.roles.Merchant" class="d-none d-sm-block">
            <b-link to="/processed-orders" class="text-decoration-none menu-color">
              PROCESSING
            </b-link>
          </b-nav-item>
          <b-nav-item v-if="user.role !== fixed.roles.Merchant" class="d-none d-sm-block">
            <b-link to="/packed-orders" class="text-decoration-none menu-color">
              PACKAGES
            </b-link>
          </b-nav-item>

          <b-nav-item-dropdown v-if="user.role === fixed.roles.Master || user.role === fixed.roles.Norway"
                               text="STATS" class="dropdown-nav-link">
            <b-dropdown-item>
              <b-link to="/stats/history" class="text-decoration-none">
                HISTORY
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <b-link to="/stats/workshop-stats" class="text-decoration-none">
                WORKSHOP
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <b-link to="/stats/poland-stats" class="text-decoration-none">
                POLAND
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <b-link to="/stats/website-stats" class="text-decoration-none">
                BDBILDELER
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <b-link to="/stats/regos-stats" class="text-decoration-none">
                REGOS
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <b-link to="/stats/as-stats" class="text-decoration-none">
                AIRSUSPENSION
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <b-link to="/stats/invoices" class="text-decoration-none">
                INVOICES
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item>
              <b-link to="/stats/total-stock-value" class="text-decoration-none">
                TOTAL STOCK
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item v-if="user.showHidden">
              <b-link to="/stats/overview" class="text-decoration-none">
                PLATFORM INSIGHTS
              </b-link>
            </b-dropdown-item>
            <b-dropdown-item v-if="user.showHidden">
              <b-link to="/supplies-demo" class="text-decoration-none">
                SUPPLIERS DEMO
              </b-link>
            </b-dropdown-item>
          </b-nav-item-dropdown>

          <!-- Merchant Routes -->
<!--          <b-nav-item v-if="user.role === fixed.roles.Master || user.role === fixed.roles.Merchant"-->
<!--                      class="d-none d-sm-block mr-2">-->
<!--            <b-link to="/merchant-pos" class="text-decoration-none menu-color">-->
<!--              POS-->
<!--            </b-link>-->
<!--          </b-nav-item>-->
          <b-nav-item v-if="user.role === fixed.roles.Merchant"
                      class="d-none d-sm-block">
            <b-link to="/merchant-order" class="text-decoration-none menu-color">
              ORDER
            </b-link>
          </b-nav-item>
          <b-nav-item v-if="user.role === fixed.roles.Merchant"
                      class="d-none d-sm-block">
            <b-link to="/merchant-order-history" class="text-decoration-none menu-color">
              ORDER HISTORY
            </b-link>
          </b-nav-item>

        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown right class="user-menu">
            <!-- Using 'button-content' slot -->
            <template #button-content>
              <span class="user-chip">
                <span class="user-avatar">{{ userInitial }}</span>
                <span class="text-uppercase user-name">{{ user.username || 'Please Log In' }}</span>
              </span>
            </template>
            <b-dropdown-item href="#" disabled>Profile</b-dropdown-item>
            <b-dropdown-item @click="logOut">Sign Out</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import axios from 'axios';
import fixed from '@/fixed';

export default {
  computed: {
    fixed() {
      return fixed;
    },
    userInitial() {
      return (this.user && this.user.username ? this.user.username : '?')
        .charAt(0)
        .toUpperCase();
    },
  },
  props: ['user'],
  methods: {
    async logOut() {
      try {
        await axios.get(`${fixed.API_URL}/log-out`, { withCredentials: true });
        localStorage.removeItem('user');
        // await this.$router.push('/login');
        window.location.reload();
      } catch (err) {
        this.$toast.error(err?.message || 'log out error');
      }
    },
  },
};
</script>

<style>
/* All rules are scoped under .app-navbar / .app-navbar-wrapper so they no
   longer leak into dropdowns and nav elements elsewhere in the app. */

.app-navbar-wrapper {
  position: sticky;
  top: 0;
  z-index: 1030;
  margin-bottom: 0.75rem;
}

.app-navbar {
  background-color: rgba(20, 22, 27, 0.88);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border-bottom: 1px solid var(--border);
  padding: 0.4rem clamp(16px, 2.2vw, 40px);
}

/* Brand */
.app-navbar .brand-logo {
  display: flex;
  align-items: center;
  padding: 0.25rem;
  margin-right: 0.75rem;
  background-color: var(--surface-2);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  cursor: default;
}

/* Nav links */
.app-navbar .nav-link {
  padding: 0.45rem 0.25rem;
  color: var(--text-muted) !important;
}

.app-navbar .menu-color,
.app-navbar .nav-link > span {
  display: inline-block;
  padding: 0.3rem 0.65rem;
  border-radius: var(--radius-sm);
  color: var(--text-muted) !important;
  font-size: 0.8125rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  transition: color 0.15s ease, background-color 0.15s ease;
}

.app-navbar .menu-color:hover,
.app-navbar .nav-link:hover > span {
  color: var(--text) !important;
  background-color: var(--surface-2);
}

/* Active route highlight */
.app-navbar .menu-color.router-link-active {
  color: var(--accent) !important;
  background-color: var(--accent-soft);
}

/* Dropdown toggles: keep label and caret on one line at every width */
.app-navbar .dropdown-toggle {
  display: inline-flex;
  align-items: center;
}

.app-navbar .dropdown-toggle::after {
  opacity: 0.6;
  margin-left: 0.35rem;
  flex-shrink: 0;
}

/* Navbar toggler (burger) */
.app-navbar .navbar-toggler {
  border-color: var(--border-strong);
  padding: 0.4rem 0.65rem;
  border-radius: var(--radius-sm);
}

.app-navbar .navbar-toggler:focus {
  outline: none;
  box-shadow: 0 0 0 3px var(--accent-soft);
}

/* Dropdown menus inside the navbar */
.app-navbar .dropdown-menu {
  background-color: var(--surface-2);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  box-shadow: var(--shadow);
  padding: 0.35rem;
  margin-top: 0.4rem;
}

.app-navbar .dropdown-item {
  color: var(--text);
  background-color: transparent;
  border-radius: var(--radius-sm);
  padding: 0;
  font-size: 0.8125rem;
  font-weight: 600;
  letter-spacing: 0.03em;
}

.app-navbar .dropdown-item a {
  display: block;
  padding: 0.45rem 0.75rem;
  color: var(--text) !important;
  text-decoration: none !important;
}

.app-navbar .dropdown-item:hover,
.app-navbar .dropdown-item:focus {
  background-color: var(--surface-3);
}

.app-navbar .dropdown-item a.router-link-active {
  color: var(--accent) !important;
}

.app-navbar .dropdown-item.disabled,
.app-navbar .dropdown-item:disabled {
  color: var(--text-faint);
  padding: 0.45rem 0.75rem;
}

/* User menu on the right — the selector must outweigh
   `.app-navbar .nav-link > span` or its display overrides the flex gap */
.app-navbar .nav-link > span.user-chip,
.app-navbar .user-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.app-navbar .user-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--accent), #7b5bd6);
  color: #fff;
  font-size: 0.75rem;
  font-weight: 700;
  flex-shrink: 0;
}

.app-navbar .user-menu .dropdown-item {
  padding: 0.45rem 0.75rem;
}

/* Mobile collapse */
@media (max-width: 991.98px) {
  .app-navbar #nav-collapse {
    margin-top: 0.5rem;
    padding-top: 0.5rem;
    border-top: 1px solid var(--border);
    max-height: calc(100vh - 70px);
    overflow-y: auto;
  }

  .app-navbar .navbar-nav > li,
  .app-navbar .navbar-nav > .nav-item {
    margin-left: 0 !important;
    padding-left: 0 !important;
  }

  .app-navbar .navbar-nav .nav-link {
    padding: 0.3rem 0;
  }

  .app-navbar .menu-color,
  .app-navbar .nav-link > span {
    display: block;
    padding: 0.55rem 0.75rem;
    font-size: 0.9375rem;
  }

  .app-navbar .dropdown-toggle {
    display: flex;
  }

  .app-navbar .nav-link > span.user-chip {
    display: flex;
    align-items: center;
  }

  .app-navbar .navbar-nav .dropdown-menu {
    border: none;
    background-color: transparent;
    box-shadow: none;
    margin: 0 0 0 0.75rem;
    padding: 0;
    position: static !important;
    float: none;
  }

  .app-navbar .dropdown-item a,
  .app-navbar .dropdown-item.disabled {
    padding: 0.55rem 0.75rem;
    font-size: 0.9375rem;
  }
}
</style>
